import App from 'app/app.js';
import 'app/service/TranslateProviderService.js';
import { getItemDisplayName } from 'app/service/item-display.rules.ts';

function ItemDescFilter(TranslateProviderService) {
  return function (item) {
    return getItemDisplayName(item, TranslateProviderService.getLocale());
  };
}

App.filter('ItemDescFilter', ['TranslateProviderService', ItemDescFilter]);
